import AntdAlert from 'antd/lib/alert';
import React     from 'react';

export type AlertProps = {
	message?: React.ReactNode;
	description?: React.ReactNode;
	banner?: boolean;
	showIcon?: boolean;
	closable?: boolean;
	onClose?: () => void;
	type?: 'info' | 'warning' | 'error' | 'success';
	style?: React.CSSProperties;
}

const Alert = (props: AlertProps) => {
	return (
		<AntdAlert
			description={props.description}
			message={props.message}
			banner={props.banner}
			showIcon={props.showIcon}
			type={props.type}
			style={props.style}
			closable={props.closable}
			onClose={props.onClose}
		/>
	);
};

export default Alert;
